module.exports = __webpack_public_path__ + "static/media/Graphics_6.b87bb53b.png";